export const dtgCarTypeList = [
    {dtgCarType:"",dtgCarTypeNm:"전체"}
    ,{dtgCarType:"11",dtgCarTypeNm:"시내버스"}
    ,{dtgCarType:"12",dtgCarTypeNm:"농어촌버스"}
    ,{dtgCarType:"13",dtgCarTypeNm:"마을버스"}
    ,{dtgCarType:"14",dtgCarTypeNm:"시외버스"}
    ,{dtgCarType:"15",dtgCarTypeNm:"고속버스"}
    ,{dtgCarType:"16",dtgCarTypeNm:"전세버스"}
    ,{dtgCarType:"17",dtgCarTypeNm:"특수여객"}
    ,{dtgCarType:"21",dtgCarTypeNm:"일반택시"}
    ,{dtgCarType:"22",dtgCarTypeNm:"개인택시"}
    ,{dtgCarType:"31",dtgCarTypeNm:"일반화물"}
    ,{dtgCarType:"32",dtgCarTypeNm:"개별화물"}
    ,{dtgCarType:"41",dtgCarTypeNm:"비사업용"}
];